import { render } from "./persons-table.vue?vue&type=template&id=a3d6e83c"
import script from "./persons-table.vue?vue&type=script&lang=js"
export * from "./persons-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__